<template>
    <img
        class="img-fluid"
        src="@/assets/img/tv-+.png"
        alt="Mulher sorridente segurando um controle remoto em frente a um fundo vermelho, ao lado do texto promocional da Claro destacando o melhor da TV e do streaming juntos."
    />
</template>
